'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SplitNavItem", {
    enumerable: true,
    get: function() {
        return SplitNavItem;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useSplitNavItem = require("./useSplitNavItem");
const _renderSplitNavItem = require("./renderSplitNavItem");
const _useSplitNavItemStylesstyles = require("./useSplitNavItemStyles.styles");
const SplitNavItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useSplitNavItem.useSplitNavItem_unstable)(props, ref);
    (0, _useSplitNavItemStylesstyles.useSplitNavItemStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useSplitNavItemStyles_unstable')(state);
    return (0, _renderSplitNavItem.renderSplitNavItem_unstable)(state);
});
SplitNavItem.displayName = 'SplitNavItem';
